// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import type { SxProps } from "@outschool/backpack";

import { useSession } from "@outschool/ui-auth";
import { useExperiment } from "@outschool/ui-experiments";
import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

import DesktopCategoryNavbar from "./DesktopCategoryNavbar";
import MobileCategoryNavbar from "./MobileCategoryNavbar";
import useNavbarCategoriesFiltered from "./navbarCategories";
import useNavbarCategoriesFilteredTreatment from "./navbarCategoriesTreatment";

export default function CategoryNavbar({ sx = {} }: { sx?: SxProps }) {
  const isMobile = useIsMobile();

  const navbarCategoriesFiltered = useNavbarCategoriesFiltered();

  const { isLoggedIn, currentUser, currentUserHasLoaded } = useSession();
  const hasNoEnrollments = currentUser?.firstPaidEnrollment === null;
  const { variant, trigger } = useExperiment({
    currentUserHasLoaded: currentUserHasLoaded,
    experimentName: "RemoveOneTimeActivitiesFromNavbar",
  });

  const isTreatment =
    (!isLoggedIn || (isLoggedIn && hasNoEnrollments)) &&
    variant === "treatment";
  React.useEffect(() => {
    if (!isLoggedIn || (isLoggedIn && hasNoEnrollments)) {
      trigger();
    }
  }, [trigger, isLoggedIn, hasNoEnrollments]);

  const navbarCategoriesFilteredTreatment =
    useNavbarCategoriesFilteredTreatment();
  const selectedNavbarCategories = isTreatment
    ? navbarCategoriesFilteredTreatment
    : navbarCategoriesFiltered;

  const navBarMemo = React.useMemo(() => {
    return isMobile ? (
      <MobileCategoryNavbar categories={selectedNavbarCategories} sx={sx} />
    ) : (
      <DesktopCategoryNavbar categories={selectedNavbarCategories} sx={sx} />
    );
  }, [isMobile, sx, selectedNavbarCategories]);
  return <nav>{selectedNavbarCategories.length > 0 && navBarMemo}</nav>;
}
